import { DASHBOARD_ITEM_API_NAMES } from '@src/constants/commons';

import { COLORS_PALETTE } from '../../../constants';

/**
 * Extracts all data keys from metrics array (excluding 'key')
 * @param {Array} metrics - Array of metric objects
 * @returns {Set} Set of data keys found in metrics
 */
export const extractDataKeys = metrics => {
  const dataKeysSet = new Set();
  metrics.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== 'key') {
        dataKeysSet.add(key);
      }
    });
  });
  return dataKeysSet;
};

/**
 * Builds aggregations mapping from widget aggregations and data metrics
 * Filters aggregations to only include those that exist in the data
 * Falls back to dynamic detection if no valid aggregations found
 * @param {Object} aggregations - Widget aggregations configuration
 * @param {Array} metrics - Array of metric objects from data
 * @returns {Array} Array of aggregation configs with aggregation, displayType, and color
 */

export const buildAggregationsMapping = ({ aggregations = {}, metrics = [], chartType = 'bar', apiName  }) => {
  if (!metrics || !Array.isArray(metrics) || metrics.length === 0) {
    return [];
  }
  let aggregationsMapping = [];

  switch (apiName) {
    case DASHBOARD_ITEM_API_NAMES.SCHEDULES_COMPLIANCE_HIST:
      aggregationsMapping = buildAggregationsMappingForScheduleCompliance({ metrics, chartType });
      break;
    case DASHBOARD_ITEM_API_NAMES.NUMBER_METRICS_DASHBOARD:
      aggregationsMapping = buildAggregationsMappingForNumberMetricsDashboard({ metrics, aggregations });
      break;
    default:
      aggregationsMapping = buildAggregationsMappingForScheduleCompliance({ metrics, chartType });
      break;
  }

  return aggregationsMapping;
};

export const buildAggregationsMappingForScheduleCompliance = ({ metrics, chartType }) => {
  const dataKeysSet = extractDataKeys(metrics);
  return Array.from(dataKeysSet).map((dataKey, index) => ({
    aggregation: dataKey,
    displayType: chartType || 'bar',
    color: COLORS_PALETTE[index % COLORS_PALETTE.length],
  }));
};


export const buildAggregationsMappingForNumberMetricsDashboard = ({ metrics, aggregations }) => {
  const dataKeysSet = extractDataKeys(metrics);
 
  return Object.entries(aggregations)
  .map(([aggregationKey, config]) => ({
    ...config,
    aggregation: aggregationKey,
  }))
  .filter(e => {
    const hasDisplayType = e !== undefined && Boolean(e?.displayType);
    const existsInData = dataKeysSet.has(e?.aggregation);
    return hasDisplayType && existsInData;
  });
};